module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-news-switch"
  }, [_c('div', {
    staticClass: "ushk-news-switch__h"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "ushk-news-switch__b"
  }, [_c('jin-switch', {
    class: {
      'is-open': _vm.isOpen
    },
    attrs: {
      "on-text": "",
      "off-text": "",
      "width": 36
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0975cbc","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/Switch.vue
// module id = eMRG
// module chunks = 1